import React from 'react';
import { useState } from 'react';
import '../../Default.css';
import './ZoomableImage.css'
import type ZoomableImageType from './zoomableImageType'

const ZoomableImage = (props: {image: ZoomableImageType}) => {

    const [zoom, setZoom] = useState(false as boolean);

    const zoomedImageWidth: number = props.image.originalWidth/props.image.originalHeight;

    const isZoomingAvailable = (): boolean => {
        return (
            window.screen.width < props.image.originalWidth && 
            window.screen.width < window.screen.height
        ) ? true : false;
    }

    const zoomInMap = (): void => {
        if (isZoomingAvailable()) 
        {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto",
              })
            setZoom(true);
        }
    }

    const zoomOutMap = (): void => {
        setZoom(false);
    }

    return (
        <>
    
            <div className='zoomable-image-box' onClick={() => zoomInMap()}>
                {isZoomingAvailable() && <span className='zoom-in-info'>Click/tap on map to zoom it in</span>}
                <img src={props.image.src} alt={props.image.alt} className='photo'/>
                {props.image.copyright &&
                <div className='copyright copyright-tekst'>
                    <a href={props.image.copyright.url}>link to source of image ({props.image.copyright.domainName})</a>
                </div>
                }
            </div>

            {zoom && 
            <div className='zoom' 
                style={{
                    height: '100vh', 
                    width: `calc(100vh * ${zoomedImageWidth})`,
                }} 
                onClick={ () => zoomOutMap() }
            >        
                <img style={{height:'100%'}} src={props.image.src} alt={props.image.alt} className='photo' />
                <div className='zoom-info'>
                    <span className='zoom-out'>
                        Click/tap on map to zoom it out
                    </span>
                </div>
            </div>}
    
        </>
    );
};

export default ZoomableImage;
